import * as actions from 'actions';
import pagingMaker from 'reducersMakers/pagingMaker';

export default pagingMaker({
  fetchType: actions.CHAT_RESOURCES_FETCH,
  fetchSuccessType: actions.CHAT_RESOURCES_FETCH_SUCCESS,
  fetchErrorType: actions.CHAT_RESOURCES_FETCH_ERROR,
  possiblePageUpdateType: actions.CHAT_RESOURCES_UPDATE_POSSIBLE_PAGE
});



/** WEBPACK FOOTER **
 ** ./src/members/state/chat/paging/chatResources/reducer.js
 **/